import React from "react";
import { LoaderProvider } from "./LoaderContext";
import { EditorProvider } from "./EditorContext";
import { ErrorProvider } from "./ErrorContext";
import { ShirtAreaProvider } from "./ShirtAreaContext";
import { WindowProvider } from "./WindowContext";
import { GalleryProvider } from "./GalleryContext";
import { StepProvider } from "./StepContext";

const composeProviders = (...providers) => {
  return ({ children }) =>
    providers.reduceRight(
      (acc, Provider) => <Provider>{acc}</Provider>,
      children
    );
};

const CombinedProviders = composeProviders(
  WindowProvider,
  ErrorProvider,
  StepProvider,
  LoaderProvider,
  ShirtAreaProvider,
  GalleryProvider,
  EditorProvider
);

function RootProvider({ children }) {
  return <CombinedProviders>{children}</CombinedProviders>;
}

export default RootProvider;
